/* ============
 * The initial state of the profile module.
 * ============
 */
export default {
  users: [],
  user: {
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    gender: null,
    dob: '',
    designation: '',
    address: '',
    profile_image_url: '',
    country_code: '',
    username: ''
  },
  totalCount: 0,
  userCount: [],
  isUsersloading: false,
  isSent: false
};
